// extracted by mini-css-extract-plugin
export default {"pagination":"style-pagination-1DEpf","paginationBtn":"style-paginationBtn-1pq8l","paginationBtnActive":"style-paginationBtnActive-2yPgp"};